import { render } from "./EditDepartment.vue?vue&type=template&id=69e835de"
import script from "./EditDepartment.vue?vue&type=script&lang=js"
export * from "./EditDepartment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__